<!-- Alert Messages -->
<p *ngIf="form['error'] == false && form['message']">
    <app-ncs-alert [message]="form['message']" type="success" />
</p>
<p *ngIf="form['error'] ==  true && form['message']">
    <app-ncs-alert [message]="form['message']" type="danger" />
</p>

<!-- Invitation Form -->
<form #uiForm="ngForm" class="row">
    <div class="col-lg-3 col-md-6 mb-2">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Collaborators.FORM.EMAIL' | translate }}</mat-label>
            <input matInput type="email" id="loginId" name="loginId" required #emailField="ngModel"
                [(ngModel)]="form.data['loginId']" (change)="checkDuplicate(form.data['loginId'],form.data['role'])">
        </mat-form-field>
        <mat-error *ngIf="form.inputerror['loginId']">
            {{form.inputerror["loginId"]}}
        </mat-error>
    </div>

    <!-- Role Field -->
    <!-- <div class="col-auto mb-3">
        <select #field class="form-select form-select-sm me-3" id="role"
            [disabled]="form.error || form.data['loginId']===undefined"
            (change)="checkDuplicate(form.data['loginId'],form.data['role']) " name="role"
            [(ngModel)]="form.data['role']" required style="width: 200px;">
            <option selected disabled value="undefined">{{ 'Collaborators.SELECT.ROLE' | translate }}</option>
            <option *ngFor="let c of roles" value="{{ c }}">{{ c | translate }}</option>
        </select>
       
        <span style="color:red; width: 200px; margin: 0; padding: 0;">
            {{form.inputerror["role"]}}
        </span>
    </div> -->

    <div class="col-lg-3 col-md-6 mb-2">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'Collaborators.SELECT.ROLE' | translate }}</mat-label>
            <mat-select #field id="role" name="role" [(ngModel)]="form.data['role']" required
                [disabled]="form.error || form.data['loginId']===undefined"
                (selectionChange)="checkDuplicate(form.data['loginId'],form.data['role'])">
                <mat-option disabled [value]="undefined">
                    {{ 'Collaborators.SELECT.ROLE' | translate }}
                </mat-option>
                <mat-option *ngFor="let c of roles" [value]="c">
                    {{ c | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="form.inputerror['role']">
            {{form.inputerror["role"]}}
        </mat-error>
    </div>


    <!-- Action Buttons -->
    <!-- <div class="col-auto">
        <button (click)="save()" type="button" class="btn btn-outline-primary btn-sm me-1"
            [disabled]="uiForm.invalid || datavalidate === false">
            <i class='bx bx-mail-send'></i> {{ 'Collaborators.BUTTONS.INVITE' | translate }}
        </button>
        <button [title]="'BUTTONS.ADD_NEW' | translate" class="btn btn-sm btn-outline-primary me-1"
            (click)="resetForm()">
            <i class="fa fa-plus" style="margin-right: 5px;"></i> {{ 'Collaborators.BUTTONS.ADD_NEW' | translate }}
        </button>
        
        <span class="text-danger ms-3">{{ form.inputerror["applicationRoleId"] }}</span>
    </div> -->
    <div class="col-lg-6 col-md-6 mb-2">
        <div class="d-flex align-items-center gap-3">
            <!-- Invite Button -->
            <button mat-stroked-button color="primary" class="" (click)="save()"
                [disabled]="uiForm.invalid || datavalidate === false">
                <mat-icon>forward_to_inbox</mat-icon>
                {{ 'Collaborators.BUTTONS.INVITE' | translate }}
            </button>

            <!-- Add New Button -->
            <button mat-stroked-button color="primary" class="" (click)="resetForm()"
                [title]="'BUTTONS.ADD_NEW' | translate">
                <mat-icon>add</mat-icon>
                {{ 'Collaborators.BUTTONS.ADD_NEW' | translate }}
            </button>
        </div>
        <!-- Error Messages -->
        <span class="text-danger ms-3">{{ form.inputerror["applicationRoleId"] }}</span>
    </div>
</form>

<!-- Collaborators Table -->

<div class="table-container mb-3">
    <div class="table-responsive table-scrollable">
        <table class="table table-bordered table-sticky-header" style="vertical-align: middle;">
            <thead>
                <tr>
                    <th class="text-center" style="width: 5%;">{{ 'Collaborators.TABLE.S_NO' | translate }}</th>
                    <th style="width: 30%;">{{ 'Collaborators.TABLE.EMAIL' | translate }}</th>
                    <th>{{ 'Collaborators.TABLE.ROLE' | translate }}</th>
                    <th>{{ 'Collaborators.TABLE.STATUS' | translate }}</th>
                    <th style="width: 20%;">{{ 'Collaborators.TABLE.ACTIONS' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let e of form.list; let i = index">
                    <td class="text-center" style="width: 5%;">{{ pageIndex(i) }}</td>
                    <td style="width: 30%;">{{e["loginId"]}}</td>
                    <td><span class="badge bg-light text-dark border h6">{{e["role"] | translate }}</span></td>
                    <td *ngIf="e.status !== 'Accept'" style="width: 20%;">
                        <span class="access-key-text" style="white-space: nowrap;"> {{e["status"] | translate }} </span>
                    </td>
                    <!-- <td *ngIf="e.status === 'Accept'">
                        <select [(ngModel)]="e.status" (change)="changeStatus(e.id, e.status)"
                            class="form-select form-select-sm" id="status" name="status">
                            <option value="" disabled>{{ 'Collaborators.SELECT.STATUS' | translate }}</option>
                            <option value="Accept">{{ 'Collaborators.STATUS.ACCEPT' | translate }}</option>
                            <option value="Reject">{{ 'Collaborators.STATUS.REJECT' | translate }}</option>
                            <option value="Pending">{{ 'Collaborators.STATUS.PENDING' | translate }}</option>
                            <option value="Blocked">{{ 'Collaborators.STATUS.BLOCKED' | translate }}</option>
                        </select>
                    </td> -->
                    <td *ngIf="e.status === 'Accept'" style="width: 20%;">
                        <mat-form-field appearance="outline" class="w-100">
                            <!-- <mat-label>{{ 'Collaborators.SELECT.STATUS' | translate }}</mat-label> -->
                            <mat-select [(ngModel)]="e.status" (selectionChange)="changeStatus(e.id, e.status)"
                                name="status" id="status">
                                <mat-option value="" disabled>{{ 'Collaborators.SELECT.STATUS' | translate
                                    }}</mat-option>
                                <mat-option value="Accept">{{ 'Collaborators.STATUS.ACCEPT' | translate }}</mat-option>
                                <mat-option value="Reject">{{ 'Collaborators.STATUS.REJECT' | translate }}</mat-option>
                                <mat-option value="Pending">{{ 'Collaborators.STATUS.PENDING' | translate
                                    }}</mat-option>
                                <mat-option value="Blocked">{{ 'Collaborators.STATUS.BLOCKED' | translate
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                    <!-- Actions -->
                    <td>
                        <!-- <div class="d-flex  align-items-center justify-content-start p-0 m-0">
                            <button [title]="'Collaborators.BUTTONS.DELETE' | translate"
                                class="btn btn-sm btn-outline-danger me-1" (click)="delete(e.id)">
                                <i class="fa fa-trash fs-6   p-0"></i>
                            </button>
                            <button *ngIf="e['status']==='Accept'"
                                [title]="'Collaborators.BUTTONS.BLOCK_ACCESS' | translate"
                                class="btn btn-sm btn-outline-danger me-1" (click)="changeStatus(e.id, 'Blocked')">
                                <i class="fa fa-window-close fs-6   p-0"></i>
                            </button>
                        </div> -->

                        <div class="d-flex align-items-center justify-content-start gap-1">
                            <!-- Delete Button -->
                            <button mat-stroked-button color="warn" class="icon-center icon-width"
                                (click)="delete(e.id)" [matTooltip]="'Collaborators.BUTTONS.DELETE' | translate"
                                matTooltipPosition="above">
                                <mat-icon class="icon-compact">delete</mat-icon>
                            </button>

                            <!-- Block Access Button (shown conditionally) -->
                            <button *ngIf="e['status']==='Accept'" mat-stroked-button color="warn"
                                class="icon-center icon-width" (click)="changeStatus(e.id, 'Blocked')"
                                [matTooltip]="'Collaborators.BUTTONS.BLOCK_ACCESS' | translate"
                                matTooltipPosition="above">
                                <mat-icon class="icon-compact">block</mat-icon>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</div>
<app-list-header [$parent]="getSelf()"></app-list-header>